import React from "react";
import { Card, Divider, Typography } from "antd";
import Wash_InwardedBin from "../../../../components/Wash/Report/Wash_InwardedBin/Wash_InwardedBin";
import "../../../../styles/global-ui.css";

const Wash_InwardedBinPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Inward / Outward Bin
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View washing inward and outward bin movement reports
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <Wash_InwardedBin userData={userData} />
      </Card>
    </div>
  );
};

export default Wash_InwardedBinPage;